import React, { useState, useEffect, useRef } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import Finalizar from './FinalizarCompra.jsx';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faUserNurse } from '@fortawesome/free-solid-svg-icons';
import FinalizarCompra from './FinalizarCompra.jsx'
import jsPDF from 'jspdf';
const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

const ACTUALIZAR_STOCK = gql`
  mutation actualizarStock($id: ID!, $nuevoStock: Int) {
    actualizarStock(_id: $id, stock: $nuevoStock) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: String
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function formatFechaGMT5() {
  const fecha = new Date();
  const offset = 0*60; // GMT-5
  const localTime = new Date(fecha.getTime() + offset * 60 * 1000);
  const year = localTime.getFullYear();
  const month = (localTime.getMonth() + 1).toString().padStart(2, '0');
  const day = localTime.getDate().toString().padStart(2, '0');
  const hours = localTime.getHours().toString().padStart(2, '0');
  const minutes = localTime.getMinutes().toString().padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function GetProductos(props) {
  const [carrito, setCarrito] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [total, setTotal] = useState(0);
  const inputRef = useRef(null);
  const { loading, error, data } = useQuery(GET_PRODUCTOS);
  const [actualizarStockProducto] = useMutation(ACTUALIZAR_STOCK);
  const productoSeleccionadoRef = useRef(null);
  const [estado, setEstado] = useState("esperando");
  const [fecha, setFecha] = useState(formatFechaGMT5());
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [carritoLocal, setCarritoLocal] = useState([]);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal(); // Recalcular el total cuando el carrito cambia
  }, [carrito]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (productoSeleccionadoRef.current) {
        if (e.key === 'ArrowUp') {
          modificarCantidad(productoSeleccionadoRef.current, 1);
        } else if (e.key === 'ArrowDown') {
          modificarCantidad(productoSeleccionadoRef.current, -1);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const buscarYAgregarProducto = (codigo) => {
    if (!data || !data.getProductos) {
      console.error('Datos de productos no disponibles');
      alert('Datos de productos no cargados. Por favor, intente nuevamente.');
      return;
    }

    const productoFiltrado = data.getProductos.find(
      (producto) => producto.codigo === codigo
    );

    if (productoFiltrado) {
      agregarAlCarrito(productoFiltrado);
    } else {
      alert('Producto no encontrado');
    }
  };

  const agregarAlCarrito = async (producto) => {
    const productoEnCarrito = carrito.find((item) => item._id === producto._id);

    if (productoEnCarrito) {
      if (productoEnCarrito.cantidad <= producto.stock) {
        const carritoActualizado = carrito.map((item) =>
          item._id === producto._id
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
        setCarrito(carritoActualizado);

        // const nuevoStock = producto.stock - 1;
        // await actualizarStockProducto({
        //   variables: { id: producto._id, nuevoStock },
        // });
      } else {
        alert('No hay suficiente stock disponible para este producto.');
      }
    } else {
      if (producto.stock > 0) {
        setCarrito([...carrito, { ...producto, cantidad: 1 }]);

        // const nuevoStock = producto.stock - 1;
        // await actualizarStockProducto({
        //   variables: { id: producto._id, nuevoStock },
        // });
      } else {
        alert('No hay suficiente stock disponible para este producto.');
      }
    }
  };

  const modificarCantidad = async (productId, cantidad) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );
    const productoEnData = data.getProductos.find(
      (producto) => producto._id === productId
    );

    if (!productoEnCarrito || !productoEnData) return;

    const nuevaCantidad = productoEnCarrito.cantidad + cantidad;

    if (nuevaCantidad <= 0) {
      return eliminarProductoDelCarrito(productId);
    }

    if (productoEnData.stock === 0) {
      alert('No hay suficiente stock disponible para este producto.');
      return;
    }

    const carritoActualizado = carrito.map((item) =>
      item._id === productId ? { ...item, cantidad: nuevaCantidad } : item
    );
    setCarrito(carritoActualizado);

    // const nuevoStock = productoEnData.stock - cantidad;
    // await actualizarStockProducto({
    //   variables: { id: productId, nuevoStock },
    // });
  };

  useEffect(() => {
    setCarritoLocal(carrito);  // Actualiza carritoLocal cuando carrito cambie
  }, [carrito]);
  
  const eliminarProductoDelCarrito = async (productId) => {
    const productoEnCarrito = carrito.find(
      (producto) => producto._id === productId
    );

    if (productoEnCarrito) {
      // const nuevoStock =
      //   data.getProductos.find((producto) => producto._id === productId).stock +
      //   productoEnCarrito.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: productId, nuevoStock },
      // });
    }

    const carritoActualizado = carrito.filter(
      (producto) => producto._id !== productId
    );
    setCarrito(carritoActualizado);
  };

  const eliminarTodoElCarrito = async () => {
    for (let producto of carrito) {
      // const nuevoStock =
      //   data.getProductos.find((item) => item._id === producto._id).stock +
      //   producto.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: producto._id, nuevoStock },
      // });
    }
    setCarrito([]);
    localStorage.setItem('carrito', JSON.stringify([]));
  };

  {/*const handleFiltroChange = (e) => {
    setFiltro(e.target.value);
  };*/}

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarYAgregarProducto(filtro);
      setFiltro('');
    }
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal = producto.codigo === "1"
        ? (producto.precio * producto.cantidad) + 200
        : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };
  
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const handleFiltroChange = (e) => {
    const filtro = e.target.value.toLowerCase();
    setFiltro(filtro);
    const productosFiltrados = data.getProductos.filter((producto) =>
      producto.nombre.toLowerCase().includes(filtro)
    );
    setProductosFiltrados(productosFiltrados);
  };
  
  const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);


  const handleCompraClick = async () => {
    for (const producto of carrito) {
      const { _id, nombre, imagen, codigo, precio, stock, cantidad } = producto;

      await actualizarStock({
        variables: {
          id: _id,
          nuevoNombre: nombre,
          nuevaImagen: imagen,
          nuevoCodigo: codigo,
          nuevoPrecio: precio,
          nuevoStock: stock - cantidad,
        },
      });
    }

    // Limpiar el carrito
    localStorage.removeItem('carrito');
    setCarrito([]);
  };

   // Generar mensaje de WhatsApp
   const generarMensajeWhatsapp = () => {
    let mensaje = `Hola ${nombreCliente}, gracias por tu compra.\n\nDetalles de compra:\n`;

    carritoLocal.forEach((producto) => {
      mensaje += `${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${producto.precio}\n`;
    });

    mensaje += `\nTotal del pedido: ${carritoLocal.reduce((total, prod) => total + (prod.precio * prod.cantidad), 0)}\n`;
    mensaje += `\nDirección de entrega: ${direccionCliente}\n`;
    mensaje += `Nota: ${notaPedido}`;

    return encodeURIComponent(mensaje);
  };

  // Generar PDF con datos del cliente y productos
  const generarPDF = () => {
    const doc = new jsPDF();
    
    // Añadir datos del cliente
  
    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);
    
    // Añadir detalles del pedido
    doc.text("Detalles de la compra", 10, 50);
    carritoLocal.forEach((producto, index) => {
      doc.text(`${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${producto.precio}`, 10, 60 + (index * 10));
    });

    const total = carritoLocal.reduce((total, prod) => total + (prod.precio * prod.cantidad), 0);
    doc.text(`Total del pedido: ${total}`, 10, 70 + (carritoLocal.length * 10));

    doc.save('pedido.pdf');  // Guarda el PDF en el navegador
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal);

    // Crear pedido en la base de datos
    await nuevoPedido({
      variables: {
        estado,
        fecha,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

     // Actualizar stock, generar PDF y abrir WhatsApp
     handleCompraClick();
     {/**generarPDF();
 
     // Redirigir a WhatsApp en una nueva ventana o reutilizar una existente
     const numeroWhatsApp = `57${whatsappCliente}`;
     const mensaje = generarMensajeWhatsapp();
     const enlaceWhatsApp = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensaje}`;
     window.open(enlaceWhatsApp, 'whatsappWindow');*/}
 
     // Limpiar los campos del formulario
     setNombreCliente("");
     setFecha(formatFechaGMT5());
     setDireccionCliente("");
     setWhatsappCliente("");
     setNotaPedido("");
   };

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="">
    <a className="btn-prod-sincodigo btn" href="productos-sin-codigo">
      Buscar por nombre
    </a>
    <a className="crear-producto btn" href="/crear-product">
      Crear producto
    </a>
    <a className="editar-producto btn" href="/buscar-y-agregar">
      Editar producto
    </a>
    
    <div className="container">
      <div className="row img-fondo">
        <input
          ref={inputRef}
          type="text"
          placeholder="Escanee el código de barras o escribe el nombre del producto"
          value={filtro}
          onChange={handleFiltroChange}
          onKeyPress={handleKeyPress}
          style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
        />
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
            {productosFiltrados.map((producto, index) => (
              <div key={index} className="col-2 mb-4">
                <div className="card card-legumbre">
                  <div className="card-body">
                    <h6 className="card-title">{producto.nombre}</h6>
                    <p className="card-text">
                      <img src={producto.imagen} width="35px" alt={producto.nombre} />
                      <h4>{producto.precio}</h4>
                    </p>
                    <button
                      className="btn btn-primary btn-legumbre"
                      onClick={() => agregarAlCarrito(producto)}
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        
        <div className="col-md-9">
          <ul>
            {carrito.slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >
                <div className="producto-nombre">
                  <img src={producto.imagen} width="40px" alt="" /> {producto.nombre}
                </div>
                <div className="producto-precio">
                  ${producto.codigo === "1"
                    ? (producto.precio * 1000) + 200
                    : producto.precio}
                </div>
                <div className="producto-cantidad">
                  <button className="btn btn-primary" onClick={() => modificarCantidad(producto._id, -1)}>
                    -
                  </button>
                  {producto.cantidad}
                  <button className="btn btn-primary" onClick={() => modificarCantidad(producto._id, 1)}>
                    +
                  </button>
                </div>
                <div className="producto-subtotal">
                  Subtotal: $
                  {producto.codigo === "1"
                    ? (producto.precio * producto.cantidad) + 200
                    : producto.precio * producto.cantidad}
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-2">
          {carrito.length > 0 && (
            <>
              
              
              <form onSubmit={pedidoSubmit}>
          {/*<input type="hidden" name="estado" value="esperando" />
          <input type="text" name="fecha" value={fecha} /> {/* Fecha con GMT-5 
          <h3>Cliente</h3>
          <input placeholder="nombre completo" value={nombreCliente} onChange={evt => setNombreCliente(evt.target.value)} />
          <h3>Direccion</h3>
          <input placeholder="ejemplo: calle 123 #01-01" value={direccionCliente} onChange={evt => setDireccionCliente(evt.target.value)} />
          <h3>Whatsapp (se usara para notificaciones del pedido)</h3>
          <input placeholder="ejemplo: 3010000000" value={whatsappCliente} onChange={evt => setWhatsappCliente(evt.target.value)} />
          <h3>Notas de pedido</h3>
          <input placeholder="ejemplo: informacion adicional del pedido" value={notaPedido} onChange={evt => setNotaPedido(evt.target.value)} />
          <input type="hidden" value={JSON.stringify(carritoLocal, null, 2)} />
          <br />
          <br />*/}
         <h1><button className="btn btn-salida"><h3>Finalizar Venta</h3></button></h1> 
        </form>
        
        <a className="btn btn-salida" href="/finalizar-compra">
                <h3>Registrar venta al cliente</h3>
              </a>

        <h1>Total a pagar: ${total.toFixed(0)}</h1>
            </>
          )}
        </div>
      </div>
    </div>
  </div>
  );
  
}

export default GetProductos;
